import { z } from 'zod';
import { CAMPAIGN_TYPES } from './campaign.js';
import { AI_SUGGEST_TONES } from './ai.js';
import { emailTemplateBlockSchema } from '../mail/emailTemplateBlocks.js';
export const AI_TEMPLATE_GOALS = ['meeting', 'reply', 'click', 'awareness'];
export const AI_TEMPLATE_LENGTHS = ['short', 'standard'];
export const AI_TEMPLATE_CTA_STYLES = ['soft_question', 'calendar', 'link', 'none'];
export const emailTemplateAiGenerateSchema = z
    .object({
    project_id: z.string().uuid(),
    campaign_type: z.enum(CAMPAIGN_TYPES).default('cold_outreach'),
    tone: z.enum(AI_SUGGEST_TONES).optional().default('friendly'),
    goal: z.enum(AI_TEMPLATE_GOALS).optional().default('reply'),
    length: z.enum(AI_TEMPLATE_LENGTHS).optional().default('short'),
    cta_style: z.enum(AI_TEMPLATE_CTA_STYLES).optional().default('soft_question'),
    /** Verplichte vrije tekst: feiten, aanbod, context — AI mag hier niets bij verzinnen. */
    user_brief: z.string().min(20).max(8000),
    key_message: z.string().max(2000).optional(),
    cta_url: z.string().max(2000).optional(),
    calendar_link: z.string().max(2000).optional(),
    name: z.string().min(1).max(200).optional(),
    persist: z.boolean().optional().default(false),
    skip_dna_check: z.boolean().optional().default(false),
})
    .superRefine((body, ctx) => {
    if (body.goal === 'click' && body.cta_style === 'link') {
        const url = body.cta_url?.trim();
        if (!url) {
            ctx.addIssue({
                code: 'custom',
                message: 'cta_url verplicht bij doel “klik” en CTA-stijl “knop + link”',
                path: ['cta_url'],
            });
        }
    }
    if (body.goal === 'meeting' && body.cta_style === 'calendar') {
        const cal = body.calendar_link?.trim();
        if (!cal && !body.user_brief.toLowerCase().includes('http')) {
            ctx.addIssue({
                code: 'custom',
                message: 'calendar_link of een URL in je brief is nodig voor afspraak-CTA',
                path: ['calendar_link'],
            });
        }
    }
});
export const emailTemplateImproveBlockSchema = z.object({
    project_id: z.string().uuid(),
    campaign_type: z.enum(CAMPAIGN_TYPES).default('cold_outreach'),
    tone: z.enum(AI_SUGGEST_TONES).optional().default('friendly'),
    block: emailTemplateBlockSchema,
    subject_template: z.string().max(998).optional(),
});
export const emailTemplateInboxTestSchema = z.object({
    project_id: z.string().uuid(),
    lead_id: z.string().uuid().optional(),
    subject_template: z.string().min(1).max(998),
    body_text_template: z.string().max(100_000).optional(),
    body_html: z.string().max(500_000).optional(),
    body_blocks: z.unknown().optional(),
    render_mode: z.enum(['text', 'html', 'blocks']).optional(),
});
export const emailTemplateEnhanceHtmlSchema = z.object({
    project_id: z.string().uuid(),
    campaign_type: z.enum(CAMPAIGN_TYPES).default('cold_outreach'),
    tone: z.enum(AI_SUGGEST_TONES).optional().default('friendly'),
    subject_template: z.string().max(998).optional(),
    body_html: z.string().min(20).max(500_000),
    body_text_template: z.string().max(100_000).optional(),
    /** Vervang statische namen/bedrijven door {{voornaam}}, {{company}}, enz. */
    personalise: z.boolean().optional().default(true),
    /** Pas inline CSS aan op basis van Bedrijfs-DNA (kleuren, fonts). */
    apply_brand_styling: z.boolean().optional().default(true),
    skip_dna_check: z.boolean().optional().default(false),
});
export const aiEmailTemplateEnhanceHtmlResponseSchema = z.object({
    body_html: z.string().min(1).max(500_000),
    body_text_template: z.string().max(100_000).optional(),
    subject_template: z.string().max(998).optional(),
    notes: z.string().max(2000).optional(),
});
export const aiPersonaliseHtmlResponseSchema = z.object({
    body_html: z.string().min(1).max(500_000),
    body_text_template: z.string().max(100_000).optional(),
    changes: z.array(z.string().max(500)).max(30).optional(),
});
//# sourceMappingURL=emailTemplateAi.js.map